import createMetadataAPISelectors from '../../utils/api-metadata-selectors';
import { createSelector } from 'reselect';

const options = {
  name: 'activityTypes',
  baseType: 'ACTIVITY_TYPES',
  apiEndpoint: 'activity_types'
};

const metadataApiSelectors = createMetadataAPISelectors(options);

export const incidentActivityTypes = createSelector(metadataApiSelectors.values, types =>
  types.filter(ac => ac.applies_to === 'incident')
);

export const activityReportTypes = createSelector(metadataApiSelectors.values, types =>
  types.filter(ac => ac.applies_to === 'activity_report')
);

export default {
  ...metadataApiSelectors,
  incidentActivityTypes,
  activityReportTypes
};
